/* eslint-disable */
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../supabase';

const QK = ['dev-requests'];

export function useDevRequests() {
  return useQuery({
    queryKey: QK,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('dev_requests')
        .select('*')
        .order('created_at', { ascending: false });
      if (error) throw error;
      return data || [];
    },
    staleTime: 30_000,
  });
}

export function useUpdateDevRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, updates }) => {
      const { error } = await supabase
        .from('dev_requests')
        .update({ ...updates, updated_at: new Date().toISOString() })
        .eq('id', id);
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeleteDevRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const { error } = await supabase.from('dev_requests').delete().eq('id', id);
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useMarkSeen() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ request, userEmail }) => {
      const newSeen = [...new Set([...(request.seen_by || []), userEmail])];
      const { error } = await supabase
        .from('dev_requests')
        .update({ seen_by: newSeen })
        .eq('id', request.id);
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

// Step 1 of accept flow: mark request as accepted (dev is created separately via DevFormModal2)
export function useMarkRequestAccepted() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ request, notes }) => {
      const { error } = await supabase
        .from('dev_requests')
        .update({
          status:         'accepted',
          accepted_at:    new Date().toISOString(),
          designer_notes: notes || '',
          updated_at:     new Date().toISOString(),
        })
        .eq('id', request.id);
      if (error) throw error;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeclineDevRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ request, reason, userEmail }) => {
      const { error } = await supabase
        .from('dev_requests')
        .update({
          status:         'rejected',
          decline_reason: reason || '',
          updated_at:     new Date().toISOString(),
        })
        .eq('id', request.id);
      if (error) throw error;

      await supabase.from('dev_request_comments').insert({
        request_id: request.id,
        author:     userEmail,
        message:    `Request declined${reason ? ': ' + reason : ''}`,
      });
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
